import {useContext} from "react";
import pick from 'lodash.pick';
import AppContext from "../store";
import {WebRTCClient} from "@arcware/webrtc-plugin";
import {
	SYSTEM_ID_CHANGE_BUNDLE,
	SYSTEM_ID_CHANGE_SINGLE,
	SYSTEM_ID_RESET_CONFIG,
	SYSTEM_ID_RESET_CAMERA,
	SYSTEM_ID_ICUE,
	SYSTEM_ID_TOGGLE_INSPECT,
	SYSTEM_ID_TOGGLE_POWER,
	SYSTEM_ID_TOGGLE_DOOR,
	EFFECT_ID_COLOR_ONE,
	SYSTEM_ID_TOGGLE_DESK_CAMERA,
} from '../contants/presets';

export const initialActionsStore = {
	[SYSTEM_ID_CHANGE_BUNDLE]: {},
	[SYSTEM_ID_CHANGE_SINGLE]: {},
	[SYSTEM_ID_ICUE]: EFFECT_ID_COLOR_ONE,
	[SYSTEM_ID_RESET_CAMERA]: 0,
	[SYSTEM_ID_RESET_CONFIG]: 0,
	[SYSTEM_ID_TOGGLE_POWER]: 1,
	[SYSTEM_ID_TOGGLE_DOOR]: 0,
	[SYSTEM_ID_TOGGLE_INSPECT]: 0,
	[SYSTEM_ID_TOGGLE_DESK_CAMERA]: 0,
};

/*
* Developed according to the following documentation:
* https://arcware.atlassian.net/wiki/spaces/SD/pages/1251901441/Get+On+My+LVL+PC+Configurator
* */
export default (() => {
	const storedValue = localStorage.getItem('frontend-storage');
	const data = storedValue ? JSON.parse(storedValue)?.streamStore : initialActionsStore;
	let client;

  return function() {
    const ctx = useContext(AppContext);
		const {
			setSelectedOptions,
			getActiveBundle,
			getBundleById,
			options,
		} = ctx;

    return {
			client,
	    proxy: data,
      init: props => {
				if(client) return false;
				client = new WebRTCClient(props);
				window.client = client;
      },
	    emit: props => {
				if(!props) return false;
				let emitValue;
				
		    switch(props.id) {
			    case SYSTEM_ID_CHANGE_BUNDLE:
				    const activeBundle = getBundleById(props.data.id);
						emitValue = {
							[SYSTEM_ID_CHANGE_BUNDLE]: {
								...pick(activeBundle, ['bundleId', 'title']),
								selectedOptions: activeBundle.options.base.map(({id: productId}) => pick(
									(options.find(option => option.productId === productId) || {}),
									['productId', 'title', 'type']
								))
							}
						}
						break;
						
			    case SYSTEM_ID_CHANGE_SINGLE:
						emitValue = {
							[SYSTEM_ID_CHANGE_SINGLE]: {
								productId: props.data.id,
								title: props.data.title,
								type: props.data.type,
							}
						}
						break;
						
			    case SYSTEM_ID_RESET_CONFIG:
						const bundle = getActiveBundle()
						setSelectedOptions(bundle.options.base);
						emitValue = {
							[SYSTEM_ID_RESET_CONFIG]: props.data || ++ctx.streamStore[SYSTEM_ID_RESET_CONFIG],
							...pick(initialActionsStore, [
								SYSTEM_ID_ICUE,
								SYSTEM_ID_RESET_CAMERA,
								SYSTEM_ID_RESET_CONFIG,
								SYSTEM_ID_TOGGLE_POWER,
								SYSTEM_ID_TOGGLE_DOOR,
								SYSTEM_ID_TOGGLE_INSPECT,
								SYSTEM_ID_TOGGLE_DESK_CAMERA,
							])
						}
						break;
						
			    case SYSTEM_ID_ICUE:
						emitValue = {
							[SYSTEM_ID_ICUE]: props.data,
						}
						break;
						
			    case SYSTEM_ID_RESET_CAMERA:
						emitValue = {
							[SYSTEM_ID_RESET_CAMERA]: props.data || ++ctx.streamStore[SYSTEM_ID_RESET_CAMERA]
						};
						break;
						
			    case SYSTEM_ID_TOGGLE_POWER:
						emitValue = {
							[SYSTEM_ID_TOGGLE_POWER]: props.data || +!ctx.streamStore[SYSTEM_ID_TOGGLE_POWER]
						}
						break;
						
			    case SYSTEM_ID_TOGGLE_DOOR:
						emitValue = {
							[SYSTEM_ID_TOGGLE_DOOR]: props.data || +!ctx.streamStore[SYSTEM_ID_TOGGLE_DOOR]
						}
						break;
						
			    case SYSTEM_ID_TOGGLE_INSPECT:
						emitValue = {
							[SYSTEM_ID_TOGGLE_INSPECT]: props.data || +!ctx.streamStore[SYSTEM_ID_TOGGLE_INSPECT],
						}
				    break;

			    case SYSTEM_ID_TOGGLE_DESK_CAMERA:
				    emitValue = {
					    [SYSTEM_ID_TOGGLE_DESK_CAMERA]: props.data || +!ctx.streamStore[SYSTEM_ID_TOGGLE_DESK_CAMERA],
				    }
				    break;
						
			    default: break;
		    }
		
				if(client && emitValue) {
					console.log('emitValue', emitValue);
					ctx.setStreamStore(emitValue);
					client.emitUIInteraction(emitValue);
				}
	    },
    }
  }
})();
